import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';
import { readWebStorage, writeWebStorage } from './web-storage';
import { createSecureStoreKey } from './secure-store-key';

// First-entry welcome for the employer workspace (Company Page / Applications
// / agent walkthrough). Fully separate from the seeker tour persistence: a
// user can see both, once each. Mirrors lib/tour-persistence.ts.
const SEEN_PREFIX = 'tabbio_employer_welcome_seen_v1';

function storageKey(userId?: string | null) {
  return userId ? createSecureStoreKey(SEEN_PREFIX, userId) : null;
}

function readStorage(key: string) {
  if (Platform.OS === 'web') {
    return readWebStorage(key);
  }

  try {
    return SecureStore.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string) {
  if (Platform.OS === 'web') {
    writeWebStorage(key, value);
    return;
  }

  try {
    void SecureStore.setItemAsync(key, value);
  } catch {
    // Best effort: welcome persistence must never block UX.
  }
}

export function hasSeenEmployerWelcome(userId?: string | null): boolean {
  const key = storageKey(userId);
  if (!key) return true;
  return readStorage(key) === '1';
}

export function markEmployerWelcomeSeen(userId?: string | null) {
  const key = storageKey(userId);
  if (!key) return;
  writeStorage(key, '1');
}
